module.exports = __webpack_public_path__ + "img/150.853e692e.jpg";